module.exports = __webpack_public_path__ + "img/cost-icon__first-aid_room.baf0d68c.svg";